"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nutritionProgressByDateRangeQuery = void 0;
exports.nutritionProgressByDateRangeQuery = `
    fragment Macronutrients on NutritionFacts {
        calories
        carbs
        fats
        fibers
        protein
    }
    
    query fetchNutritionProgressByDateRange ($userId: Int, $range: RangeOfString!) {
        progressCollection(userId: $userId, range: $range) {
            id
            day
            date
            dayType
            nutritionFacts {
                ...Macronutrients
            }
            calorieBudgetInfo {
                calories {
                    status
                    difference
                }
                carbs {
                    status
                    difference
                }
                fats {
                    status
                    difference
                }
                fibers {
                    status
                    difference
                }
                protein {
                    status
                    difference
                }
            }
            meals {
                isCalorieTracked
            }
        }
    }
`;
//# sourceMappingURL=fetchNutritionProgressByDateRange.js.map